// @flow
import { useSelector } from "react-redux";

import type { State as OffersState } from "state/reducers/offers";

type State = {
  offers: OffersState,
};

function useDataSource(): Array<{ value: number, text: string }> {
  return useSelector<State, Array<{ value: number, text: string }>>((state) => {
    return Array.from(state.offers.items, ([key, value]) => ({
      value: key,
      text: `(${key}) ${value}`,
    }));
  });
}

export default useDataSource;
